import {GmapPlaces} from './gmap-places';
import {AlgoliaPlaces} from './algolia-places';

export function places(provider) {
    return provider === 'gmap' ? GmapPlaces : AlgoliaPlaces;
}
